import React from 'react'
import './Video.css'

const videos = () => {
  const src = "https://www.youtube.com/embed/op4hbiXlJ_s";
  return (
    <section className='video section'>
         <div className='video-container'>
         <iframe
            src={src}
            title="Youtube Player"
            frameborder="0"
            allowFullScreen
            className='video'
          />
        </div>
    </section>
  )
}

export default videos
